// Voorlezen voor kinderen die (nog) niet lezen (oprichter 1 okt 2026: "voor de kinderen wil ik de
// tekst ook kunnen laten voorlezen met een knop als ze niet kunnen lezen"). Bord: één grote knop
// bij de taken van een kind, bij de detailkaart en bij een lijstje. Hier de labels van de knop; de
// uitgesproken zinnen staan in readAloudSpeech.ts, de schakelaar van de ouderapp in readAloudApp.
export const readAloudNl = {
    /** Knop op het bord (aria-label). */
    button: 'Voorlezen',
    stop: 'Stop met voorlezen',
    /** Kleine knop op een taakrij: alleen deze taak. */
    task: '{task} voorlezen',
};
//# sourceMappingURL=readAloud.nl.js.map